import { LogTrack } from '@igetcool/base-components';
import { env } from '@utils';
/**
 *
 * @param {object} options 上报数据
 * @param {string} action  触发动作
 * @param {object} data    详情数据
 */
// 微信、App、浏览器、其他
let envText = '其他';
if (env.isApp) {
  envText = 'App';
} else if (env.isWeChat) {
  envText = '微信';
} else if (env.browser) {
  envText = '浏览器';
}
export function logReport({ params = {}, action = 'page', goodsDetail = {} }) {
  const r = this.$router.history.current;
  const { ptFlag, activityId, itemid, igc_from, discountRecommendId } = r.query || {};
  // 暂不推荐组合
  if (discountRecommendId) {
    return;
  }
  // 一键购 新一键购 常规一键购
  // 常规 领券购 砸金蛋
  // 拼团 礼品卡 兑换
  let pageName = '';
  // 售卖流程(1常规 2新一键购 3 微信投放 4 老一键购  5 常规一键购)
  // 前端自定义(10001 领券购 10002 砸金蛋 10003 拼团 购物车 30001 组合商品 30002 分销保险 30 脆香米 31)
  const sellType = {
    1: '常规',
    2: '新一键购',
    3: '微信投放',
    4: '老一键购',
    5: '常规一键购'
  };
  let sellId = goodsDetail.sellType;
  const sellName = sellType[goodsDetail.sellType];
  if (ptFlag) {
    // 拼团
    pageName = '拼团';
    sellId = 10003;
  } else if (itemid && activityId) {
    // 砸金蛋
    pageName = '砸金蛋';
    sellId = 10002;
  } else if (goodsDetail.couponUse) {
    // 领券购
    pageName = '领券购';
    sellId = 10001;
  } else {
    // 单报
    pageName = sellName;
  }

  // 默认设置
  let ops = {
    page_name: '',
    page_type: 2,
    page_title: goodsDetail.title || document.title,
    url: location.href,
    main_item_id: itemid || '',
    mall_channel: igc_from || '',
    key1: {},
    h5_open_environment: envText,   // h5页面打开环境 当前环境（微信、App、浏览器、其他 ）
    platform: 'h5',                 // 产品形态 App/wxapp/h5
  //   refer_url: 12222,
  //   main_item_id: '',
  //   main_item_type: '',
  //   module_name: '',
  //   btn_name: '',
  //   key1,
  //   duration: 0,
  };

  if (itemid) {
    ops.key1.item_id = itemid;
  }
  if (sellId) {
    ops.key1.process_id = sellId;
  }
  if (pageName) {
    ops.key1.process_name = pageName;
  }
  if (ptFlag) {
    ops.key1.pt_flag = ptFlag;
  }

  if (params.key1) {
    params.key1 = { ...ops.key1, ...params.key1 };
  }
  Object.assign(ops, params);

  // try {
  //   // 获取session中的历史记录，需要先使用page将当前信息存入session
  //   let historyPage = ISession('page_logtrack') && JSON.parse(ISession('page_logtrack'))
  //   // 上报事件为page时，重新定义历史记录
  //   if (action === 'page') {
  //     ISession('page_logtrack', JSON.stringify(ops))
  //   }
  //   // 给resetKey中定义的项重新赋值
  //   if (historyPage && resetKey.length && (ops.main_item_id === historyPage.main_item_id)) {
  //     resetKey.forEach(item => {
  //       ops[item] = historyPage[item]
  //     })
  //   }
  // } catch (error) {

  // }
  Object.keys(ops).forEach(item => {
    if (typeof ops[item] === 'object') {
      ops[item] = JSON.stringify(ops[item]);
    }
  });
  LogTrack.track(ops, action);
}
// LogTrack.track({}, 'autoTrackPage', true);